export const classes = {
  tableHead: 'whitespace-pre',
};
